import React, { useState } from "react";
import { SUBSCRIPTION_PLANS } from "../config/stripeConfig";

function SubscriptionPlans({ currentPlanId, onSelectPlan, loading }) {
	const [billingPeriod, setBillingPeriod] = useState("monthly");

	return (
		<div className="subscription-plans-container">
			<h3 className="subscription-plans-title">Choisissez votre abonnement</h3>

			<div className="billing-toggle">
				<span className={billingPeriod === "monthly" ? "active" : ""}>Mensuel</span>
				<label className="toggle-switch">
					<input
						type="checkbox"
						checked={billingPeriod === "yearly"}
						onChange={() => setBillingPeriod(billingPeriod === "monthly" ? "yearly" : "monthly")}
					/>
					<span className="toggle-slider"></span>
				</label>
				<span className={billingPeriod === "yearly" ? "active" : ""}>
					Annuel <span className="billing-savings">Économisez ~17%</span>
				</span>
			</div>

			<div className="subscription-plans-grid">
				{SUBSCRIPTION_PLANS.map((plan) => {
					const isCurrentPlan = currentPlanId === plan.idAbonnementType;
					const price = billingPeriod === "monthly" ? plan.prixMensuel : plan.prixAnnuel;
					const period = billingPeriod === "monthly" ? "/mois" : "/an";

					return (
						<div
							key={plan.idAbonnementType}
							className={`subscription-plan-card ${isCurrentPlan ? "current" : ""}`}
							style={{ borderColor: plan.color }}
						>
							{isCurrentPlan && (
								<div className="subscription-plan-badge" style={{ backgroundColor: plan.color }}>
									Plan actuel
								</div>
							)}

							<h4 className="subscription-plan-name" style={{ color: plan.color }}>
								{plan.libelle}
							</h4>

							<div className="subscription-plan-price">
								<span className="price-amount" style={{ color: plan.color }}>
									{price}€
								</span>
								<span className="price-period">{period}</span>
							</div>

							{billingPeriod === "yearly" && (
								<p className="subscription-plan-monthly-equivalent">
									soit {(plan.prixAnnuel / 12).toFixed(2)}€/mois
								</p>
							)}

							<ul className="subscription-plan-features">
								{plan.features.map((feature, index) => (
									<li key={index}>
										<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={plan.color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
											<polyline points="20 6 9 17 4 12"></polyline>
										</svg>
										<span>{feature}</span>
									</li>
								))}
							</ul>

							<button
								className="subscription-plan-button"
								style={{
									backgroundColor: isCurrentPlan ? "transparent" : plan.color,
									borderColor: plan.color,
									color: isCurrentPlan ? plan.color : "#fff"
								}}
								onClick={() => !isCurrentPlan && onSelectPlan({ ...plan, prix: price, billingPeriod })}
								disabled={isCurrentPlan || loading}
							>
								{loading ? "Chargement..." :
									isCurrentPlan ? "Plan actuel" :
									"Choisir ce plan"}
							</button>
						</div>
					);
				})}
			</div>
		</div>
	);
}

export default SubscriptionPlans;
